import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Flip from 'react-reveal/Flip';

import "./Socials.scss";

class Socials extends Component {

    icons = {
        "Github": faGithub,
        "LinkedIn": faLinkedin
    }

    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        }
    }

    render() {

        let socials = this.state.data;

        return (
            <Row className="justify-content-center">
                {socials.map((social, index) => (
                    <Col key={index} className="socials-col">
                        <a className="icon" href={social.link} target="_blank" rel="noopener noreferrer">
                            <Flip left delay={700} duration={1000} fraction={1}>
                                <FontAwesomeIcon icon={this.icons[social.name]} />
                            </Flip>
                        </a>
                    </Col>
                ))}
            </Row>
        );

        // return (
        //     <ul>
        //         {socials.map((social, index) => (
        //             <li key={index}>

        //                 <a className="icon" href={social.link} target="_blank" rel="noopener noreferrer">
        //                     <Flip left delay={600} duration={1000} fraction={1}>
        //                         <FontAwesomeIcon icon={this.icons[social.name]} />
        //                     </Flip>
        //                 </a>

        //             </li>
        //         ))}
        //     </ul>
        // );
    }
}

export default Socials;